import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import moment from 'moment';
import 'moment/locale/fr';
import 'moment/locale/ar';
import 'moment/locale/es';
import 'moment/locale/pt';
import 'moment/locale/tr';
import 'moment/locale/de';
import 'moment/locale/it';
import 'moment/locale/nl';
import 'moment/locale/pl';

import fr from './locales/fr.json';
import en from './locales/en.json';
import ar from './locales/ar.json';
import es from './locales/es.json';
import pt from './locales/pt.json';
import tr from './locales/tr.json';
import de from './locales/de.json';
import it from './locales/it.json';
import nl from './locales/nl.json';
import pl from './locales/pl.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      ar: { translation: ar },
      es: { translation: es },
      pt: { translation: pt },
      tr: { translation: tr },
      de: { translation: de },
      it: { translation: it },
      nl: { translation: nl },
      pl: { translation: pl }
    },
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

// Override Arabic locale to use Western Arabic numerals (0-9) instead of Eastern (٠١٢٣٤٥٦٧٨٩)
moment.updateLocale('ar', {
  preparse: function (string) { return string; },
  postformat: function (string) { return string; }
});

// Sync moment locale with i18n language
moment.locale(i18n.language || 'fr');
i18n.on('languageChanged', (lng) => {
  moment.locale(lng || 'fr');
});

export default i18n;
